<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <sports-report-table></sports-report-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import sportsReportTable from './SportsReportTable.vue'

  export default {
    name: 'SportsReportTable',
    components: {sportsReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/sportsReport/SportsReport.vue